/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const marketReferenceMarketDtoSchema = z.object({
  industry: z.optional(z.string()),
  size2026: z.optional(z.string()),
  size2031: z.optional(z.string()),
  cagr: z.optional(z.string()),
  url: z.optional(z.string()),
});
